import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsGovernanceContentSectionCls: string;
		}
	},

	slug: string
}

class Info extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Governance Info Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsGovernanceContentSectionCls || '', 'investors_governance_info', { animCls: 'animate__fadeIn', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Info;